module.exports = __webpack_public_path__ + "img/selected4-min.8af7eabb.png";